//Import required modules
import React from 'react';
import Dropdown from 'react-bootstrap/Dropdown';
import PropTypes from 'prop-types'

//Import BootStrap Containers
import Row from 'react-bootstrap/Row'
import Col from 'react-bootstrap/Col'
import Card from 'react-bootstrap/Card'

//Import Data
import UserRow from './UserRow';
import { randomizeColors, trashAll, downloadCsv, downloadJson, downloadJpeg, downloadArr} from '../../store/actions';

//UserPalette Component
const UserPalette = (props, {store}) =>
{
    let theme = store.getState().theme;
    let userWindow = store.getState().userWindow;
    let colorArr = store.getState().colorArr;
    let userPalette = store.getState().userPalette;
    return (
    <div>
        <Card.Body className={`text-center ${theme}`}>
            <Row className="card-row">
                <Col className="text-left">
                    <i className={`fa fa-random btn-random ${theme}`}
                        onClick={() => store.dispatch(randomizeColors(colorArr, userWindow))}
                        title='Select 10 colors randomly'></i>
                </Col>
                <Col className="text-center">
                    <h5 className={`card-title ${theme}`}>My Palette</h5>
                    <Dropdown>
                        <Dropdown.Toggle 
                            id="dropdown-basic"
                            className={`dropdown-custom ${theme}`}
                            title='Download color codes'>
                            <i className={`fa fa-download ${theme}`}></i>
                        </Dropdown.Toggle>

                        <Dropdown.Menu>
                            <Dropdown.Item onClick={() => store.dispatch(downloadCsv(userWindow, userPalette))}>CSV</Dropdown.Item>
                            <Dropdown.Item onClick={() => store.dispatch(downloadArr(userWindow, userPalette))}>JSON</Dropdown.Item>
                            <Dropdown.Item onClick={() => store.dispatch(downloadJpeg(userWindow, userPalette, theme))}>JPEG</Dropdown.Item>
                        </Dropdown.Menu>
                    </Dropdown>                
                </Col>
                <Col className="text-right">
                    <i className={`fa fa-trash-o btn-trash ${theme}`}
                        onClick={() => store.dispatch(trashAll())}
                        title='Trash all'></i>
                </Col>
            </Row>
        </Card.Body>

        <Card.Footer className={`${theme}`}>
            <div className="user-palette">
                {   
                    (userPalette.length === 0)?
                    <p className={`text-center ${theme}`}>No colors selected</p>:
                        userPalette.map((d, i) =>
                            <UserRow key={i} 
                                        userArr={d}/>)
                }
            </div>
        </Card.Footer>

    </div>
    )
}

UserPalette.contextTypes = {
    store: PropTypes.object
}

export default UserPalette